import React from 'react'
import styled from 'styled-components'
import CheckMark from 'assets/checkbox-mark.svg?react'
import { GLOBAL_COLORS } from 'theme/global-theme'
import { Text, TextTypes } from 'components'

interface CustomProps {
  checked: boolean
}

interface CheckboxProps {
  className?: string
  checked: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  text?: string
  width?: number
  height?: number
  fontType?: TextTypes
}

type Props = CustomProps & React.HTMLProps<HTMLDivElement>

const ElementContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })<CustomProps>`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`
const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  &:hover {
    opacity: 0.5;
  }
`

export const IconForCheckbox = styled(CheckMark)`
  width: 24px;
  height: 24px;
  ${({ theme }) => theme.mediaWidth.Mobile`
		width: 12px; 
		height: 12px;
`}
  stroke: ${({ theme }) => theme.iconColor};
`

const StyledCheckbox = styled.div<Props>`
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ theme }) => theme.mediaWidth.Mobile`
		width: 18px; 
		height: 18px;
	`};
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  background: ${GLOBAL_COLORS.transparent};
  border: ${(props) => (props.checked ? '2px' : '1px')} solid ${({ theme }) => theme.checkboxBorder};
  margin: ${(props) => (props.checked ? '0px 5px 0px 0px' : '1px 6px 1px 1px')};
  transition: all 150ms;
`

export const Checkbox: React.FC<CheckboxProps> = ({
  className,
  checked,
  width = 48,
  height = 48,
  fontType = 'p',
  ...props
}) => {
  return (
    <ElementContainer>
      <label>
        <CheckboxContainer className={className}>
          <HiddenCheckbox checked={checked} {...props} />
          <StyledCheckbox checked={checked} width={width} height={height}>
            {checked && <IconForCheckbox />}
          </StyledCheckbox>
        </CheckboxContainer>
      </label>
      <Text type={fontType}>{props.text}</Text>
    </ElementContainer>
  )
}
